<template>
  <section>
    <div class="row"><slot></slot></div>
  </section>
</template>
